var map = {
	"./level1/pic10-3.png": [
		78190,
		78190
	],
	"./level1/pic11-3.png": [
		51323,
		51323
	],
	"./level1/pic12-3.png": [
		25917,
		25917
	],
	"./level1/pic14-3.png": [
		22294,
		22294
	],
	"./level1/pic15-3.png": [
		88362,
		88362
	],
	"./level1/pic16-3.png": [
		32028,
		32028
	],
	"./level1/pic17-3.png": [
		88034,
		88034
	],
	"./level1/pic18-3.png": [
		52752,
		52752
	],
	"./level1/pic2-3.png": [
		23410,
		23410
	],
	"./level1/pic20-3.png": [
		92188,
		92188
	],
	"./level1/pic21-3.png": [
		73513,
		73513
	],
	"./level1/pic22-3.png": [
		35373,
		35373
	],
	"./level1/pic23-3.png": [
		36060,
		36060
	],
	"./level1/pic24-3.png": [
		74425,
		74425
	],
	"./level1/pic26-3.png": [
		88887,
		88887
	],
	"./level1/pic27-3.png": [
		86330,
		86330
	],
	"./level1/pic28-3.png": [
		63104,
		63104
	],
	"./level1/pic29-3.png": [
		391,
		391
	],
	"./level1/pic3-3.png": [
		45718,
		45718
	],
	"./level1/pic30-3.png": [
		91813,
		91813
	],
	"./level1/pic32-3.png": [
		64469,
		64469
	],
	"./level1/pic33-3.png": [
		53611,
		53611
	],
	"./level1/pic34-3.png": [
		29897,
		29897
	],
	"./level1/pic35-3.png": [
		85274,
		85274
	],
	"./level1/pic36-3.png": [
		93405,
		93405
	],
	"./level1/pic38-3.png": [
		18620,
		18620
	],
	"./level1/pic39-3.png": [
		10724,
		10724
	],
	"./level1/pic4-3.png": [
		33116,
		33116
	],
	"./level1/pic40-3.png": [
		29774,
		29774
	],
	"./level1/pic41-3.png": [
		62297,
		62297
	],
	"./level1/pic42-3.png": [
		27823,
		27823
	],
	"./level1/pic44-3.png": [
		33018,
		33018
	],
	"./level1/pic45-3.png": [
		71137,
		71137
	],
	"./level1/pic46-3.png": [
		27754,
		27754
	],
	"./level1/pic47-3.png": [
		66870,
		66870
	],
	"./level1/pic48-3.png": [
		21076,
		21076
	],
	"./level1/pic5-3.png": [
		92064,
		92064
	],
	"./level1/pic6-3.png": [
		22623,
		22623
	],
	"./level1/pic8-3.png": [
		68535,
		68535
	],
	"./level1/pic9-3.png": [
		99200,
		99200
	],
	"./level2/pic10-3.png": [
		3175,
		3175
	],
	"./level2/pic11-3.png": [
		13534,
		13534
	],
	"./level2/pic12-3.png": [
		61717,
		61717
	],
	"./level2/pic14-3.png": [
		10259,
		10259
	],
	"./level2/pic15-3.png": [
		92122,
		92122
	],
	"./level2/pic16-3.png": [
		6891,
		6891
	],
	"./level2/pic17-3.png": [
		42081,
		42081
	],
	"./level2/pic18-3.png": [
		37661,
		37661
	],
	"./level2/pic2-3.png": [
		66638,
		66638
	],
	"./level2/pic20-3.png": [
		91467,
		91467
	],
	"./level2/pic21-3.png": [
		65206,
		65206
	],
	"./level2/pic22-3.png": [
		46186,
		46186
	],
	"./level2/pic23-3.png": [
		19041,
		19041
	],
	"./level2/pic24-3.png": [
		5428,
		5428
	],
	"./level2/pic26-3.png": [
		76031,
		76031
	],
	"./level2/pic27-3.png": [
		85795,
		85795
	],
	"./level2/pic28-3.png": [
		14983,
		14983
	],
	"./level2/pic29-3.png": [
		18594,
		18594
	],
	"./level2/pic3-3.png": [
		90931,
		90931
	],
	"./level2/pic30-3.png": [
		10930,
		10930
	],
	"./level2/pic32-3.png": [
		18398,
		18398
	],
	"./level2/pic33-3.png": [
		77482,
		77482
	],
	"./level2/pic34-3.png": [
		66885,
		66885
	],
	"./level2/pic35-3.png": [
		8492,
		8492
	],
	"./level2/pic36-3.png": [
		97037,
		97037
	],
	"./level2/pic38-3.png": [
		32943,
		32943
	],
	"./level2/pic39-3.png": [
		74853,
		74853
	],
	"./level2/pic4-3.png": [
		90912,
		90912
	],
	"./level2/pic40-3.png": [
		53708,
		53708
	],
	"./level2/pic41-3.png": [
		28337,
		28337
	],
	"./level2/pic42-3.png": [
		93198,
		93198
	],
	"./level2/pic44-3.png": [
		28022,
		28022
	],
	"./level2/pic45-3.png": [
		62438,
		62438
	],
	"./level2/pic46-3.png": [
		65433,
		65433
	],
	"./level2/pic47-3.png": [
		80372,
		80372
	],
	"./level2/pic48-3.png": [
		7758,
		7758
	],
	"./level2/pic5-3.png": [
		65426,
		65426
	],
	"./level2/pic6-3.png": [
		87234,
		87234
	],
	"./level2/pic8-3.png": [
		91168,
		91168
	],
	"./level2/pic9-3.png": [
		68147,
		68147
	],
	"./level3/pic10-3.png": [
		41424,
		41424
	],
	"./level3/pic11-3.png": [
		40355,
		40355
	],
	"./level3/pic12-3.png": [
		57172,
		57172
	],
	"./level3/pic14-3.png": [
		79813,
		79813
	],
	"./level3/pic15-3.png": [
		40079,
		40079
	],
	"./level3/pic16-3.png": [
		75310,
		75310
	],
	"./level3/pic17-3.png": [
		32039,
		32039
	],
	"./level3/pic18-3.png": [
		47708,
		47708
	],
	"./level3/pic2-3.png": [
		38901,
		38901
	],
	"./level3/pic20-3.png": [
		98583,
		98583
	],
	"./level3/pic21-3.png": [
		32994,
		32994
	],
	"./level3/pic22-3.png": [
		89578,
		89578
	],
	"./level3/pic23-3.png": [
		11535,
		11535
	],
	"./level3/pic24-3.png": [
		68324,
		68324
	],
	"./level3/pic3-3.png": [
		13809,
		13809
	],
	"./level3/pic4-3.png": [
		88930,
		88930
	],
	"./level3/pic5-3.png": [
		53794,
		53794
	],
	"./level3/pic6-3.png": [
		74893,
		74893
	],
	"./level3/pic8-3.png": [
		72571,
		72571
	],
	"./level3/pic9-3.png": [
		11933,
		11933
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 60807;
module.exports = webpackAsyncContext;